import { FolderPlus, Info } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '../../../i18n/config';
import { Button } from '../../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip';

interface CreateCaseButtonProps {
  onClick: () => void;
}

const CreateCaseButton: React.FC<CreateCaseButtonProps> = ({ onClick }) => {
  const { t, i18n } = useTranslation();

  return (
    <TooltipProvider>
      <div className="relative w-full">
        <Button
          onClick={onClick}
          className="w-full gap-2 shadow-md hover:shadow-lg transition-all pr-9"
          dir={getLanguageDirection(i18n.language)}
        >
          <FolderPlus className="w-4 h-4" />
          <span>{t('components.cases.createNew')}</span>
        </Button>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className="absolute right-2.5 top-1/2 -translate-y-1/2 text-white/70 hover:text-white cursor-default z-10"
              onClick={(e) => e.stopPropagation()}
            >
              <Info size={14} />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-xs text-center">
            {t('components.cases.createNewCaseTooltip')}
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};

export default CreateCaseButton;
